export default __webpack_public_path__ + "static/media/4.c6094381.jpg";